export default __webpack_public_path__ + "static/media/screenshot20.eeaca4e1.jpg";